export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber)
        return "—";
    const digits = phoneNumber.replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("1")) {
        return `1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phoneNumber;
};
export const formatDuration = (seconds) => {
    if (seconds === undefined || seconds === null)
        return "—";
    if (seconds === 0)
        return "0s";
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    const parts = [];
    if (hours > 0) {
        parts.push(`${hours}h`);
    }
    if (mins > 0) {
        parts.push(`${mins}m`);
    }
    if (secs > 0 || parts.length === 0) {
        parts.push(`${secs}s`);
    }
    return parts.join(" ");
};
export const formatTimeDetailed = (seconds) => {
    if (!seconds || seconds < 0 || isNaN(seconds) || !isFinite(seconds))
        return "—";
    if (seconds < 60) {
        return `${Math.round(seconds)}s`;
    }
    else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.round(seconds % 60);
        return `${minutes}m ${remainingSeconds}s`;
    }
    else {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h ${minutes}m`;
    }
};
export const formatSpeedToCareDuration = (seconds) => {
    if (!seconds || seconds <= 0)
        return "0s";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0)
        return `${hours}h ${minutes}m`;
    if (minutes > 0)
        return `${minutes}m ${secs}s`;
    return `${secs}s`;
};
export const getDaySuffix = (day) => {
    if (day % 10 === 1 && day !== 11)
        return "st";
    if (day % 10 === 2 && day !== 12)
        return "nd";
    if (day % 10 === 3 && day !== 13)
        return "rd";
    return "th";
};
export const copyToClipboard = async (text, _label) => {
    try {
        await navigator.clipboard.writeText(text);
    }
    catch (err) {
        console.error("Failed to copy text: ", err);
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
    }
};
export const formatInteractionForDisplay = (interaction, formatDateTime) => {
    const formatOptionalDate = (date) => {
        return date ? formatDateTime(date) : "—";
    };
    return {
        ...interaction,
        InteractionStartDateUtc: formatDateTime(interaction.InteractionStartDateUtc),
        InteractionEndDateUtc: formatOptionalDate(interaction.InteractionEndDateUtc),
        PushNotificationSentUtc: formatOptionalDate(interaction.PushNotificationSentUtc),
        PushNotificationReceivedUtc: formatOptionalDate(interaction.PushNotificationReceivedUtc),
        SecureMessageSentUtc: formatOptionalDate(interaction.SecureMessageSentUtc),
        SecureMessageReadUtc: formatOptionalDate(interaction.SecureMessageReadUtc),
        SecureMessageDeliveredUtc: formatOptionalDate(interaction.SecureMessageDeliveredUtc),
        CallbackFromMessageIdUtc: formatOptionalDate(interaction.CallbackFromMessageIdUtc),
        InteractionStartDate: interaction.InteractionStartDate
            ? formatDateTime(interaction.InteractionStartDate)
            : formatDateTime(interaction.InteractionStartDateUtc),
        SecureMessageSent: formatOptionalDate(interaction.SecureMessageSent),
        SecureMessageRead: formatOptionalDate(interaction.SecureMessageRead),
        CallbackFromMessageId: formatOptionalDate(interaction.CallbackFromMessageId),
        CallDurationSeconds: formatDuration(interaction.CallDurationSeconds),
        NotificationInSeconds: formatDuration(interaction.NotificationInSeconds),
        ReadInSeconds: formatDuration(interaction.ReadInSeconds),
        CallbackInSeconds: formatDuration(interaction.CallbackInSeconds),
        CallbackDurationSeconds: formatDuration(interaction.CallbackDurationSeconds),
        InteractionTotalTime: formatDuration(interaction.InteractionTotalTime),
    };
};
//# sourceMappingURL=formatters.js.map